import Config from '@deezer/config';

import mainConfig from './config.json';

const config = new Config(mainConfig);

export default config;
